import { Moment } from 'moment'
import { useState } from 'react'

import {
  ClientDeviceByDayHeader,
  ClientDeviceByDayTable,
  ClientDeviceByRangeDayTable,
  FilterClientDeviceByDay,
  TotalClientDeviceByRangeDayTable,
} from '@/components/pages/ClientDevice/ClientDeviceByDay'
import { DateType } from '@/types'

import { useClientDeviceByDay } from './ClientDeviceByDay.hooks'

export type FilterDate = {
  type: DateType
  fromDate: Moment | null
  toDate: Moment | null
  totalFromDate: Moment | null
  totalToDate: Moment | null
}

export const defaultFilterDate: FilterDate = {
  type: DateType.NO_SELECT,
  fromDate: null,
  toDate: null,
  totalFromDate: null,
  totalToDate: null,
}

const ClientDeviceByDay = () => {
  const {
    getClientDeviceByDay,
    responseClientDevice,
    responseClientDeviceLoading,
    exportExcelClientDeviceByDay,
    getClientDeviceByRangeDay,
    responseClientDeviceByRangeDay,
    responseClientDeviceByRangeDayLoading,
    exportExcelByRangeDay,
    getTotalClientByRangeDay,
    responseTotalClientDevice,
    responseTotalClientDeviceLoading,
    exportExcelTotalClientByRangeDay,
    exportClientDeviceByDayLoading,
    exportClientDeviceByRangeDayLoading,
    exportClientDeviceLoading,
  } = useClientDeviceByDay()

  const [dateFilter, setDateFilter] = useState<Moment | null>()
  const [dateRangeFilter, setDateRangeFilter] = useState<FilterDate>(defaultFilterDate)

  return (
    <>
      <ClientDeviceByDayHeader />
      <FilterClientDeviceByDay
        getClientDeviceByDay={getClientDeviceByDay}
        exportExcelClientDeviceByDay={exportExcelClientDeviceByDay}
        getClientDeviceByRangeDay={getClientDeviceByRangeDay}
        exportExcelClientDeviceByRangeDay={exportExcelByRangeDay}
        getTotalClientDeviceByRangeDay={getTotalClientByRangeDay}
        exportExcelTotalClientDeviceByRangeDay={exportExcelTotalClientByRangeDay}
        setDateFilter={setDateFilter}
        dateFilter={dateFilter}
        setDateRangeFilter={setDateRangeFilter}
        dateRangeFilter={dateRangeFilter}
        exportClientDeviceLoading={exportClientDeviceLoading}
        exportClientDeviceByDayLoading={exportClientDeviceByDayLoading}
        exportClientDeviceByRangeDayLoading={exportClientDeviceByRangeDayLoading}
      />
      {dateFilter && responseClientDevice && (
        <ClientDeviceByDayTable
          responseClientDevice={responseClientDevice}
          responseClientDeviceLoading={responseClientDeviceLoading}
          dateFilter={dateFilter}
        />
      )}

      {responseClientDeviceByRangeDay && dateRangeFilter.fromDate && dateRangeFilter.toDate && (
        <ClientDeviceByRangeDayTable
          responseClientDeviceByRangeDay={responseClientDeviceByRangeDay}
          responseClientDeviceByRangeDayLoading={responseClientDeviceByRangeDayLoading}
        />
      )}

      {responseTotalClientDevice && dateRangeFilter.totalFromDate && dateRangeFilter.totalToDate && (
        <TotalClientDeviceByRangeDayTable
          responseTotalClientDevice={responseTotalClientDevice}
          responseTotalClientDeviceLoading={responseTotalClientDeviceLoading}
        />
      )}
    </>
  )
}

ClientDeviceByDay.displayName = 'ClientDeviceByDay'
export default ClientDeviceByDay
